'use strict';

import './Polyfills';

import Widget from './Widget';
import WidgetList from './WidgetList';
import ConditionsValidator from './ConditionsValidator';
import Util from './Util';

(function () {

    var widgetsCases = [];
    var widgetsList = new WidgetList();
    var widgetsVariables = {};

    console.log('Leadhit: init widget system.');

    var widgetSystemCookieName = 'lh_widget_system_pages_counter';

    // Get widgets config
    //let widgetsConfig = window.lh_widgets_conf.widgets;
    var widgetsConfig = false;
    if (typeof window.top.lh_widgets_conf_demo !== 'undefined') {
        widgetsConfig = window.top.lh_widgets_conf_demo.widgets;
    } else {
        if (typeof window.top.lh_widgets_conf !== 'undefined') {
            widgetsConfig = window.top.lh_widgets_conf.widgets;
        } else {
            Util.console.warn('Leadhit config: Site not found or not active');
            return;
        }
    }

    Util.console.log('Widgets config', widgetsConfig);

    if (typeof window.top.lh_widgets_conf_demo !== 'undefined') {
        widgetsCases = window.top.lh_widgets_conf_demo.testcases || [];
    } else {
        widgetsCases = window.top.lh_widgets_conf.testcases || [];
    }

    var pagesCounterCookieValue = Util.cookie.get(widgetSystemCookieName);
    if (!pagesCounterCookieValue) {
        Util.cookie.set(widgetSystemCookieName, 0, { expires: 10 });
    } else {
        var newPagesCounterCookieValue = parseInt(pagesCounterCookieValue) + 1;
        Util.cookie.set(widgetSystemCookieName, newPagesCounterCookieValue);
    }

    window.lhWidgetSystem = {
        register : registerWidget,
        getWidgetVariablesByWidgetId : getWidgetVariablesByWidgetId
    };

    var widgetsIDsToShow = getWidgetIdsToShow()
    Util.console.log('widgetsIDsToShow', widgetsIDsToShow)

    widgetsIDsToShow.forEach(function (widgetId) {
        // Set widget name
        // Set widget visible state to boolean "false" as default
        widgetsVariables[widgetId] = {
            widgetName : widgetsConfig[widgetId].name,
            widget_shown : false,
            url: window.location.href
        };
    })

    var widgetsIDsAndValidators = []
    for(let i = 0; i < widgetsIDsToShow.length; i++) {
        let widgetId = widgetsIDsToShow[i]

        let conditions_and = []
        let conditions_or = []
        if(window.Leadhit.store.state.siteSettings.hasOwnProperty('next_vers_features') && 
        window.Leadhit.store.state.siteSettings.next_vers_features.hasOwnProperty('widgets') && 
        window.Leadhit.store.state.siteSettings.next_vers_features.widgets === true) {
          conditions_and = widgetsConfig[widgetId].config.conditions_and
          conditions_or = widgetsConfig[widgetId].config.conditions_or
        } else {
          conditions_and = widgetsConfig[widgetId].show_params.conditions_and
          conditions_or = widgetsConfig[widgetId].show_params.conditions_or
        }

        var validator = new ConditionsValidator(
            conditions_and,
            conditions_or,
            widgetId
        )

        if(validator.validate(true)) {
            widgetsIDsAndValidators.push({'id': widgetId, 'validator': validator})
        }
    }
    Util.console.log('Widgets IDs to show', widgetsIDsToShow);
    if(widgetsIDsAndValidators.length > 0) {
        // For each widget widget name
        widgetsIDsAndValidators.forEach(function (widgetConf) {
            // Get widget config by name
            var widgetData = widgetsConfig[widgetConf.id];
            // Init widget
            let widgetOptions = {}
            if(window.Leadhit.store.state.siteSettings.hasOwnProperty('next_vers_features') && 
              window.Leadhit.store.state.siteSettings.next_vers_features.hasOwnProperty('widgets') && 
              window.Leadhit.store.state.siteSettings.next_vers_features.widgets === true) {
                widgetOptions = widgetData.config
            } else {
              widgetOptions = widgetData.show_params
            }
            var widget = new Widget(
                widgetConf.id,
                widgetData.name,
                widgetData.type,
                widgetOptions,
                widgetConf.validator
            );
            
            // Add widget in widgets list
            widgetsList.put(widgetConf.id, widget);
        });
    }

    /**
     * Add show interface to widget
     * @param {Object} widgetInterface - javascript object width show field
     * @param {String} widgetId
     */
    function registerWidget(widgetInterface, widgetId) {
        Util.console.log('Run to register widget by id: ' + widgetId);
        var widget = widgetsList.getById(widgetId);

        if (widget) {
            Util.console.log('Widget by ID: ' + widgetId + ' exists');
            widget.addShowInterface(widgetInterface);
        } else {
            throw new Error('Failed to register widget named "' + widgetId + '"');
        }
    }

    /**
     * Return object with widget states options
     * @param {String} widgetId
     * @returns {Object}
     */
    function getWidgetVariablesByWidgetId(widgetId) {
        return widgetsVariables[widgetId];
    }

    function checkWidgetActive(widgetsConfig) {
      let widgets = []
      for(let i = 0; i < Object.keys(widgetsConfig).length; i++) {
        if(!Object.values(widgetsConfig)[i].hasOwnProperty('active') || Object.values(widgetsConfig)[i].active === true) {
          let widget = JSON.parse(JSON.stringify(Object.values(widgetsConfig)[i]))
          widget.id = Object.keys(widgetsConfig)[i]
          widgets.push(widget)
        }
      }
      return widgets
    }

    function getWidgetIdsToShow() {
      var widgetIds = [];
      var LeadID = window.Leadhit.getUID()
      if(window.Leadhit.store.state.siteSettings.hasOwnProperty('next_vers_features') && 
        window.Leadhit.store.state.siteSettings.next_vers_features.hasOwnProperty('widgets') && 
        window.Leadhit.store.state.siteSettings.next_vers_features.widgets === true) {
        
        let widgets = checkWidgetActive(widgetsConfig)
        if(widgetsCases.length === 0) {
          widgetIds = widgets.map(function(widget) {
            return widget.id
          })
        }
        else {
          widgets.forEach(function(widget) {
            let widget_index = widgetsCases.findIndex(function (case_item) {
              if(case_item.hasOwnProperty(widget.id)) return true
              else return false
            })
            if(widget_index === -1 && widget.active) {
              widgetIds.push(widget.id)
            }
          })

          widgetsCases.forEach(function (dictionary) {
            var widgetId = getCaseID(dictionary, LeadID);
            if (typeof widgetId === 'undefined') return;
            widgetIds.push(widgetId);
          })
        }
      } else {
        widgetsCases.forEach(function (dictionary) {
          var widgetId = getCaseID(dictionary, LeadID);
          if (typeof widgetId === 'undefined') return;
          widgetIds.push(widgetId);
        })
      }
      return widgetIds;
    }

    function getCaseID(cases, lead_id) {
        /*
            This is ugly hack for a\b cases.
            Because someone decided that combining AB tests
            and a sign of widget activity is a good idea
        */

        let casesValues = Object.values(cases)

        if (casesValues.length === 1 && casesValues[0] === 1) {
            return Object.keys(cases)[0]
        } else {
            let leadIdFormated = lead_id.slice(-4);
            let intLeadID = parseInt(leadIdFormated, 16) - 1
            let divider = Object.values(cases).reduce((a, b) => a + b, 0)
            let reminder = intLeadID % divider

            let bound = 0

            let sortedCases = []

            for (let key of Object.keys(cases)) {
                sortedCases.push([key, cases[key]])
            }

            sortedCases.sort((a, b) => a[1] - b[1])

            for (let widget of sortedCases) {

                bound += widget[1]

                if (reminder < bound) {
                    return widget[0]
                }
            }
        }
    }

})();
